/**
 * 券平台预发、发券相关常量
 */

import { CouponWallScene } from "@/types/coupon-wall";
import { SYSTEM_PLATFORM } from "../constant";

// 券平台 wm_dplatform 和系统平台映射关系
export const COUPON_SYSTEM_PLATFORM_MAP = {
  [SYSTEM_PLATFORM.IOS]: 'ios',
  [SYSTEM_PLATFORM.ANDROID]: 'android',
  [SYSTEM_PLATFORM.HARMONY_OS]: 'ohos',
  [SYSTEM_PLATFORM.UNKNOWN]: 'android',
} as const;

// appId
export const COUPON_WALL_APPID_MAP = {
  [CouponWallScene.FX_CENTER]: 'mtunion_h5',
  [CouponWallScene.WAIMAI]: undefined,
}
